export default __webpack_public_path__ + "static/2290-204b06f4e866692ba40aab1a5082cd11.gif";